import React, { useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

function Editor(props) {
  const [value, setValue] = useState('');

  return <ReactQuill theme="snow" value={props.description}    onChange={(e) => props.onEditorStateChange(e)} style={{height:'100px', borderRadius:'20px'}} placeholder='Write your content'/>;
}
export default Editor;